<h2 mat-dialog-title>Lernabschnitt {{ data?.id ? "bearbeiten" : "anlegen" }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-tab-group>
        <mat-tab label="Basisdaten">
            <mat-dialog-content [formGroup]="form" class="grid">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Titel</mat-label>
                    <input matInput formControlName="title" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Typ</mat-label>
                    <input matInput formControlName="learningSectionType" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Layout</mat-label>
                    <mat-select formControlName="learningSectionLayout">
                        @for (learningSectionLayout of learningSectionLayouts$ | async; track learningSectionLayout.id) {
                            <mat-option [value]="learningSectionLayout.id">{{ learningSectionLayout.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="full-width" style="padding-bottom:20px;">
                    <mat-slide-toggle
                            formControlName="showCopyright"
                            labelPosition="after"
                            class="slide-toggler"
                    >
                        Copyright-Hinweise für Bilder aktivieren
                    </mat-slide-toggle>
                </div>

                <mat-form-field>
                    <mat-label>Anwendung</mat-label>
                    <mat-select formControlName="consumer">
                        @for (consumer of consumers$ | async; track consumer.id) {
                            <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Fächer/Berufe</mat-label>
                    <mat-select formControlName="subjects" multiple>
                        @for (subject of subjects$ | async; track subject.id) {
                            <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="full-width">
                    <pixl-multi-combo-entity-search
                        [label]="learningUnitLabel"
                        [observable$]="learningUnits$"
                        [namingColumn]="'title'"
                        [externalSearch]="true"
                        (onStateChange)="receiveLearningUnitData($event)"
                        (onSearchChange)="receiveLearningUnitQuery($event)"
                        (scrolledToEnd)="loadMoreLearningUnits($event)"
                        [(selectedValues)]="selectedLearningUnits"
                    >
                    </pixl-multi-combo-entity-search>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab [label]="(selectedConsumerName$ | async) || 'Metadaten'">
            <mat-dialog-content class="grid">
                <pixl-object-consumer-metadata [parentForm]="form" [objectType]="'learning_section'"></pixl-object-consumer-metadata>
            </mat-dialog-content>
        </mat-tab>
    </mat-tab-group>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Speichern</button>
    </mat-dialog-actions>
</div>
